import { render, staticRenderFns } from "./ServiceNotFound.vue?vue&type=template&id=0d234b93"
import script from "./ServiceNotFound.vue?vue&type=script&lang=js"
export * from "./ServiceNotFound.vue?vue&type=script&lang=js"
import style0 from "./ServiceNotFound.vue?vue&type=style&index=0&id=0d234b93&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports